import { formatHour, texto } from '@/shared';
import { gridSizeMdLg12, gridSizeMdLg6 } from '@/shared/constants';
import {
  Grid
} from '@mui/material';
import { useFlotasStore } from '@/store/erp';
import { CustomAutocomplete, SampleDatePicker } from '@/shared/components/ui';
import { Flota } from '@/shared/interfaces';
import { CustomAlertCard } from '@/shared/components/ui/Alerts';
import './CalendarioAgendaNoc.css'
import TimeClockComponente from '@/shared/components/ui/TimeClock/TimeClockComponente';

interface CalendarioPreagendamientoPylProps {
  form: any;
  cacheKey: string;
}

export default function CalendarioAgendaNoc({ form }: CalendarioPreagendamientoPylProps) {

  const { flotas, isLoadingFlotas } = useFlotasStore();

  const {
    reset,
    formState: { errors },
  } = form;

  return (

    <Grid item container spacing={3} justifyContent={'space-between'}>

      <CustomAutocomplete<Flota>
        disabled={false}
        size={gridSizeMdLg6}
        label={'Técnicos Disponibles'}
        name="flota"
        options={flotas || []}
        valueKey="nombre"
        actualValueKey="codigo"
        defaultValue={form.getValues().flota}
        isLoadingData={isLoadingFlotas}
        control={form.control}
        error={errors.flota}
        helperText={errors.flota?.message}
        onChangeValue={(e) => {
          console.log(e);
          reset({
            ...form.getValues(),
            flota: e
          })
        }}
      />

      {form.getValues().flota ? (
        <Grid item container {...gridSizeMdLg12} spacing={2}>
          <SampleDatePicker
            label="Fecha de instalación"
            control={form.control}
            error={errors.fecha_instalacion}
            helperText={errors.fecha_instalacion?.message}
            name="fecha_instalacion"
            textFieldKey="fecha_instalacion"
            defaultValue={null}
            size={gridSizeMdLg6}
          />

          <TimeClockComponente
            size={gridSizeMdLg6}
            control={form.control}
            error={errors.hora_instalacion}
            helperText={errors.hora_instalacion?.message}
            label='Hora de instalación'
            name='hora_instalacion'
            defaultValue={formatHour(form.getValues().hora_instalacion)}
            enableDateTypeResult={true}
          />
        </Grid>

      ) : <CustomAlertCard
        alertTitle='Información'
        alertColor='info'
        alertMessage={texto.flota_seleccion}
      />

      }
    </Grid >


  )
}
